<div class="row">
    <div class="col-md-12">
        <div class="minititulo m-2">
            Mi videoconsulta
        </div>
        <!-- <div class="titulo">
                Sala de espera
        </div> -->
    </div>
    <!-- <div class="titulo">
                Sala de espera
        </div> -->
    <br>
  </div>

<div class="grid-container">
    <div class="item1">
        <div class="row" style="width: 100%;">
            <div class="col-md-4 col-sm-12" style="padding: 10px;">
                <p class="letra-titulo">Sala de espera</p>
                <p class="letra-info">Gracias por confiar en AlmaMedis. Tu salud es nuestra prioridad y pronto serás
                    atendido
                    por uno de nuestros profesionales de la salud.</p>
            </div>
            <div class="col-md-8 col-sm-12 p-0">
                <img src="assets/images/gif-salaespera.gif" class="img-espera" alt="Sala de espera" />
            </div>
        </div>
    </div>

    <div class="item2" style="flex-direction: column; justify-content: space-around;">
        <div class="row align-items-center mb-2" style="width: 100%;">
            <!-- Imagen o círculo -->
            <div class="col-auto">
                <div class="rounded-circle bg-secondary d-flex align-items-center justify-content-center"
                    style="width: 65px; height: 65px;">
                    <img *ngIf="consulta.att_path" [src]="URL_DOCUMENTS + consulta.att_path" alt="profile-img"
                        class="img-fluid rounded-circle" style="width: 100%; height: 100%; object-fit: cover;">
                </div>
            </div>

            <!-- Nombre + Especialidad -->
            <div class="col ps-0">
                <p class="mb-0 fw-bold" style="font-size: 22px;
                font-family: 'Mulish';
                line-height: normal;
                font-weight: 600;">
                    {{consulta.nombre_doctor}} {{consulta.apellido_paterno_doctor}} {{consulta.apellido_materno_doctor}}
                </p>
                <p class="mb-0" style="font-size: 16px; color: #888; font-family: 'Mulish';">
                    {{consulta.spe_name}}
                </p>
            </div>
        </div>

        <!-- Motivo -->
        <div class="mb-2" style="width: 100%;">
            <p class="mb-1 fw-bold" style="    font-size: 16px;
              font-family: 'Mulish';
              font-weight: 600;">Motivo de Consulta</p>
            <p class="mb-0" style="font-size: 14px; color: #666; font-family: 'Mulish'; line-height: normal;">
                {{consulta.tel_doc_app_boo_reason}}
            </p>
        </div>

        <!-- Fecha -->
        <div class="mb-2" style="width: 100%;">
            <p class="mb-1 fw-bold" style="font-size: 14px; font-family: 'Mulish'; font-weight: 600;">
                Fecha de la consulta
            </p>

            <div class="row text-center"
                style="font-size: 14px; color: #444; font-family: 'Mulish'; font-weight: 500; display: flex ; align-items: center; justify-content: center;">
                <div class="col" style="display: flex;
                  align-items: center;
                  justify-content: flex-start;">
                    {{ consulta.mesTexto}} a las {{ consulta.hora?.substring(0, 5) }} hrs.
                </div>
                <!-- <div class="col-3 text-capitalize" style="    border-right: solid grey 0.5px;
                  display: flex ;
                  align-items: center;
                  justify-content: center;">
                    {{ consulta.fecha_consulta | date: 'MM' }}
                  </div> -->

                <!-- <div class="col" style="display: flex ;align-items: center;
                  justify-content: center;">
                    <p class="m-0">{{ consulta.hora?.substring(0, 5) }}hrs.</p>
                </div> -->
            </div>
        </div>


    </div>

    <div class="item3-5 p-0">
        <div class="inner-items row" style="    height: -webkit-fill-available;">

            <div class="item3 col-lg-4 col-md-12 col-sm-12 d-flex flex-column justify-content-around"
                style="height: auto;">
                <p class="letra-info">Recuerda tener tu cámara y micrófono activados para la atención.</p>
                <div style="width: 100%; display: flex; justify-content: space-around;">
                    <mat-icon>videocam</mat-icon>
                    <mat-icon>mic</mat-icon>
                </div>
            </div>

            <div class="item4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column" style="height: auto;">
                <p class="letra-info" style="width: 100%; font-size: 16px; font-weight: 700;">
                    ¿Tienes problemas para conectarte?
                </p>
                <p class="letra-info">Comunícate con nuestra mesa de ayuda para recibir apoyo.</p>
                <div style="width: 100%; display: flex; justify-content: center; gap: 5px;" href="tel:800248030">
                    <mat-icon style="color: #171994;">phone</mat-icon>
                    <p class="letra-info" style="    cursor: pointer;
    color: #171994;
    font-weight: 800;">800 248 030</p>
                </div>
            </div>

            <div class="item5 col-lg-4 col-md-12 col-sm-12 d-flex flex-column" style="height: auto;">
                <p class="letra-info" style="width: 100%; font-size: 16px; font-weight: 700;">¿Sabías que?</p>
                <p class="letra-info fade-tip" [class.fade]="fade" *ngIf="tips.length">
                    {{ tips[currentTipIndex]?.con_info_description }}
                </p>
            </div>

        </div>
    </div>


    <!-- Item 6 -->
<div class="item6">
  <div *ngIf="parametros_url.id_consulta" class="col-md-12">
    <app-carrusel [consulta]="parametros_url.id_consulta"></app-carrusel>
  </div>
</div>

<!-- Item 7: iVirtual -->
<div *ngIf="pageInfo.cus_can_ivirtual" class="vitals-card d-flex flex-column justify-content-center align-items-start item7">
  <span class="badge-new">¡NUEVO!</span>
  <h3 class="vitals-card__title mt-2">Mide tus signos vitales en segundos</h3>
  <p class="vitals-card__desc mb-2">
    Convierte tu cámara en una herramienta de salud. Con Selfie Salud IA obtén una evaluación rápida, innovadora y confiable.
  </p>
  <button type="button" class="btn btn-vitals" (click)="openModal()">Iniciar medición</button>
</div>

<!-- Item 7 (si iVirtual está oculto) o Item 8 (si iVirtual está visible) -->
<div [ngClass]="{'item7': !pageInfo.cus_can_ivirtual, 'item8': pageInfo.cus_can_ivirtual}" 
     style="flex-direction: column; justify-content: space-evenly;">

  <div class="row" style="width: 100%; gap: 10px; display: flex; flex-direction: row; flex-wrap: nowrap;">
    <div class="col-2">
      <mat-icon style="font-size: larger; color: #171994;">contact_emergency</mat-icon>
    </div>
    <div class="col-10">
      <p class="letra-titulo m-0" style="font-size: 18px;">Actualiza tu información Médica</p>
    </div>
  </div>

  <div class="row" style="width: 100%;">
    <div class="col-12">
      <p class="letra-info">
        Tu historial de atenciones está siempre disponible en el menú lateral izquierdo.
      </p>
    </div>
  </div>
</div>


    <!-- <div class="item8">8</div> -->
</div>


<!-- Backdrop -->
<div
  class="custom-backdrop"
  *ngIf="isModalOpen"
  (click)="closeModal()"
></div>

<!-- Modal -->
<div
  class="modal fade show d-block"
  *ngIf="isModalOpen"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
  <div class="modal-content custom-modal card">
    <div class="card-header d-flex justify-content-end align-items-center p-0">
      <button type="button" class="btn-close-card" aria-label="Close" (click)="closeModal()">
        <mat-icon style="width: -webkit-fill-available;
    display: flex
;
    align-items: center;
    justify-content: center;">close</mat-icon>
      </button>
    </div>

    <!-- IMPORTANTE: este body se vuelve el área scrolleable -->
    <div class="card-body modal-scroll">
      <div class="inner-frame">
        <app-medidor-signos *ngIf="isModalOpen" (requestClose)="closeModal()"></app-medidor-signos>
      </div>
    </div>
  </div>
</div>



</div>





<!--   

<div class="row">
    <div class="row col-md-12">
        <div class="card-alerta" style="margin: 0px 10px">
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <p class="letras-alerta"><mat-icon style="color:#171994;font-size: 30px;height: auto; width: auto; margin: 0 10px;">info</mat-icon>Por razones de confidencialidad, usted será dirigido automáticamente a la videollamada una vez que el médico la de por iniciada.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<br>

<div class="row">
    <div class="col-md-12">
        <p class="letra-titulo">Debes Tener Presente</p>
    </div>
</div>

<div class="row mb-2 mb-sm-4 mt-1 mt-sm-4">
    <div class="col-12">
        <div class="card-deck">

            <div class="card" >
                
                <div class="card-block px-2 px-sm-3 pt-2 pt-sm-3 pb-4">
                    <p class="card-text"></p>
                    <p class="card-text">Recuerda que debes encender tu cámara y tu micrófono, antes de iniciar tu consulta de telemedicina.</p>
                </div>
            </div>
            <div class="card" >

                <div class="card-block px-2 px-sm-3 pt-2 pt-sm-3 pb-4">
                    <p class="card-text"></p>
                    <p class="card-text">Si tienes algún problema técnico, o el profesional médico no se presenta, debes comunicarte con nuestra Mesa de Ayuda.</p>
                    <p *ngIf="consulta.telefono_plan" style="font-family: Mulish; font-weight: bold; color: #2BABB7; font-style: normal; font-size: 24px;line-height: 32px;"> {{consulta.telefono_plan}} </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
            <app-card-consulta
                [idconsulta]='parametros_url.id_consulta'>
            </app-card-consulta>
    </div>
</div>

<br>

<div class="row">
    <div *ngIf="parametros_url.id_consulta" class="col-md-12">
        <app-carrusel [consulta]="parametros_url.id_consulta">
        </app-carrusel>
    </div>
</div> -->